import { LuWallet } from 'react-icons/lu'
import { Helmet } from "react-helmet-async";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { get, post } from "../../../services/apiService";
import { FlashMessage } from '../../../utils/FlashMessage';
import { ToastContainer, toast } from "react-toastify";

const WalletSettingsV2 = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const loadingCallback = (loading) => {
    setLoading(loading);
  };

  const [data, setData] = useState({
    spend_amount: 0,
    bonus_amount: 0,
    wallet_limit: 0,
    convert_amount: 0,
    status: 'active'
  })

  useEffect(() => {
    getInvoiceSetting();
  }, []);
  const getInvoiceSetting = () => {
    loadingCallback(true);
    get("wallet-list", token)
      .then((response) => {
        if (response.success) {
          console.log("response data ",response.data)
          setData({
            spend_amount: response.data[0].spend_amount ?? 0,
            bonus_amount: response.data[0].bonus_amount ?? 0,
            wallet_limit: response.data[0].wallet_limit ?? 0,
            convert_amount: response.data[0].convert_amount ?? 0,
            status: response.data[0].status ?? 'active',
          });
          loadingCallback(false);
        }
        loadingCallback(false);
      })
      .catch((error) => {
        console.log(error);
        loadingCallback(false);
      });
  };

  const handleSubmit = () => {
    post('save-wallet', data, token)
    .then((response) => {
      if (response.success) {
        FlashMessage('Wallet settings saved successfully.', 'success');

        const wallet = Array.isArray(response.data) ? response.data[0] : response.data;

        setData({
          spend_amount: wallet.spend_amount ?? 0,
          bonus_amount: wallet.bonus_amount ?? 0,
          wallet_limit: wallet.wallet_limit ?? 0,
          convert_amount: wallet.convert_amount ?? 0,
          status: wallet.status ?? 'active',
        });

      } else {
        // Backend responded, but not success
        FlashMessage('Failed to save wallet settings. Please try again.', 'error');
      }
        loadingCallback(false);
      })
      .catch((error) => {
        FlashMessage('Failed to save wallet settings. Please try again.', 'error');
        console.log(error);
        loadingCallback(false);
      });
  }

  return (
    <div className="rounded-[27px]" style={{ backgroundColor: "#FAFAFA" }}>
      <ToastContainer />
      <Helmet>
        <title>Outlet Expense | Settings | Wallet Settings</title>
      </Helmet>
      {/* <Breadcrumb></Breadcrumb> */}
      {/* <Table data={setting} type="setting"></Table> */}
      <div className="flex justify-between items-center px-10 md:px-[27px] pt-[29px] pb-[23px]">
        <h4 className="font-semibold font-lato text-[22px] text-[#000232] capitalize flex items-center gap-2">
          <p>Wallet Settings</p>
          <span className="text-[#10204869] text-lg">
            <LuWallet />
          </span>
        </h4>

        {/* <p className="font-semibold font-lato text-xs text-[#034AFF] underline text-right">
                    <a href="#">View All</a>
                </p> */}
      </div>
      {loading && (
        <div className="custom-loader-logo">
          {/* <BeatLoader color={"#123abc"} size={20} /> */}
          <img
            className=""
            src={`${process.env.REACT_APP_ROOT_URL + "/smallLogo.png"}`}
            alt="logo"
          />
        </div>
      )}

      <div className="grid md:grid-cols-3 gap-6 col-span-3">
        {/* Spend Amount */}
        <div className="relative col-span-3 md:col-span-1">
          <label
            htmlFor="spend_amount"
            className="absolute -top-2 left-2 px-1 bg-[#FAFAFA] text-[#102048] font-semibold text-xs z-10"
          >
            Spend Amount
          </label>
          <input
            value={data.spend_amount}
            onChange={(e) => setData({
              ...data,
              spend_amount: e.target.value
            })}
            type="number"
            placeholder="Spend Amount"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-gray-700 focus:border-blue-500 focus:outline-blue-500 z-0 placeholder:text-sm"
          />
        </div>

        {/* Bonus Amount */}
        <div className="relative col-span-3 md:col-span-1">
          <label
            htmlFor="bonus_amount"
            className="absolute -top-2 left-2 px-1 bg-[#FAFAFA] text-[#102048] font-semibold text-xs z-10"
          >
            Bonus Amount
          </label>
          <input
            value={data.bonus_amount}
            onChange={(e) => setData({
              ...data,
              bonus_amount: e.target.value
            })}
            type="number"
            placeholder="Bonus Amount"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-gray-700 focus:border-blue-500 focus:outline-blue-500 z-0 placeholder:text-sm"
          />
        </div>

        {/* Wallet Limit */}
        <div className="relative  col-span-3 md:col-span-1">
          <label
            htmlFor="wallet_limit"
            className="absolute -top-2 left-2 px-1 bg-[#FAFAFA] text-[#102048] font-semibold text-xs z-10"
          >
            Wallet Limit
          </label>
          <input
            value={data.wallet_limit}
            onChange={(e) => setData({
              ...data,
              wallet_limit: e.target.value
            })}
            type="text"
            placeholder="Wallet Limit"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-gray-700 focus:border-blue-500 focus:outline-blue-500 z-0 placeholder:text-sm"
          />
        </div>

        {/* Convert Amount */}
        <div className="relative  col-span-3 md:col-span-1">
          <label
            htmlFor="email"
            className="absolute -top-2 left-2 px-1 bg-[#FAFAFA] text-[#102048] font-semibold text-xs z-10"
          >
            Convert Amount
          </label>
          <input
            value={data.convert_amount}
            onChange={(e) => setData({
              ...data,
              convert_amount: e.target.value
            })}
            type="number"
            placeholder="Convert Amount"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-gray-700 focus:border-blue-500 focus:outline-blue-500 z-0 placeholder:text-sm"
          />
        </div>

        <div className="relative flex items-center gap-2 col-span-3 md:col-span-1">
          <input
            type="checkbox"
            id="status"
            checked={data.status === 'active'}
            onChange={(e) =>
              setData((prev) => ({
                ...prev,
                status: e.target.checked ? 'active' : 'inactive',
              }))
            }
            className="h-5 w-5 text-blue-600 bg-white border-2 border-gray-300 rounded-md focus:ring-0 focus:outline-none transition duration-150 ease-in-out"
          />
          <label
            htmlFor="status"
            className="text-sm font-semibold text-[#102048]"
          >
            Active Status
          </label>
        </div>
      </div>
      <div className="relative flex items-center justify-center gap-2 col-span-3 md:col-span-1 pt-[23px]">
        <button
          onClick={handleSubmit}
          className="flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Save Changes
        </button>
      </div>

    </div>
  );
}

export default WalletSettingsV2